"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileGame = MobileGame;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const Footer_1 = require("~/components/ui/Footer");
const ui_1 = require("~/store/game/ui");
const models_1 = require("@creature-chess/models");
const TabMenu_1 = require("../../../ui/TabMenu");
const AnnouncementsBanner_1 = require("../../AnnouncementsBanner");
const TopBar_1 = require("../../TopBar");
const board_1 = require("../../board");
const cardShop_1 = require("../../cardShop/cardShop");
const help_1 = require("../../help");
const playerList_1 = require("../../playerList/playerList");
const profile_1 = require("../../profile");
const settings_1 = require("../../settings");
const MobileContentPane_1 = require("./MobileContentPane");
const OverlayComponent_1 = require("./OverlayComponent");
const GameNavBar_1 = require("./nav/GameNavBar");
function GameOverlay({ currentOverlay }) {
    const inPlayingOrReadyPhase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase === models_1.GamePhase.PLAYING ||
        state.game.roundInfo.phase === models_1.GamePhase.READY);
    if (currentOverlay === ui_1.Overlay.PLAYERS) {
        return (React.createElement(OverlayComponent_1.OverlayComponent, { title: "Players", fullscreen: true },
            React.createElement(playerList_1.PlayerList, null)));
    }
    if (currentOverlay === ui_1.Overlay.SHOP) {
        return (React.createElement(OverlayComponent_1.OverlayComponent, { title: "Card Shop", fullscreen: true },
            React.createElement(cardShop_1.CardShop, null),
            inPlayingOrReadyPhase && (React.createElement(React.Fragment, null,
                React.createElement(profile_1.PlayerGameProfile, null)))));
    }
    if (currentOverlay === ui_1.Overlay.SETTINGS) {
        return (React.createElement(OverlayComponent_1.OverlayComponent, { title: "Options" },
            React.createElement(TabMenu_1.TabMenu, { tabs: [
                    {
                        label: "Help",
                        content: React.createElement(help_1.Help, null),
                    },
                    {
                        label: "Settings",
                        content: (React.createElement("div", null,
                            React.createElement(settings_1.Settings, null),
                            React.createElement(Footer_1.Footer, null))),
                    },
                ] })));
    }
    return null;
}
function MobileGameContentPane() {
    const styles = useStyles();
    const currentOverlay = (0, react_redux_1.useSelector)((state) => state.game.ui.currentOverlay);
    return (React.createElement(MobileContentPane_1.MobileContentPane, null,
        React.createElement("div", { className: (0, classnames_1.default)(styles.boardSection, {
                [styles.boardSectionHidden]: currentOverlay !== null,
            }) },
            React.createElement(board_1.BoardContainer, null),
            React.createElement(profile_1.PlayerGameProfile, null)),
        currentOverlay !== null && (React.createElement(GameOverlay, { currentOverlay: currentOverlay }))));
}
const useStyles = (0, react_jss_1.createUseStyles)({
    game: {
        display: "flex",
        height: "100%",
        width: "100%",
        flexDirection: "column",
    },
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
    },
    boardSection: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: 0,
    },
    boardSectionHidden: {
        display: "none",
    },
});
function MobileGame() {
    const styles = useStyles();
    return (React.createElement("div", { className: styles.game },
        React.createElement(TopBar_1.TopBar, null),
        React.createElement(AnnouncementsBanner_1.AnnouncementsBanner, null),
        React.createElement("div", { className: styles.content },
            React.createElement(MobileGameContentPane, null)),
        React.createElement(GameNavBar_1.GameNavBar, null)));
}
